import * as React from 'react';
export const moneyouSvg = React.forwardRef(function moneyouSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.067 26.933A6.928 6.928 0 0 1 5.133 20c0-2.5 1.334-4.8 3.5-6.033l1.2 2.1c-1.4.8-2.3 2.3-2.3 3.933 0 2.5 2.034 4.533 4.534 4.533 1.833 0 3.466-1.066 4.166-2.766l2.234.933a6.953 6.953 0 0 1-6.4 4.233Z',
      fill: '#D40D47',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm18.467 22.7-2.234-.933A4.53 4.53 0 0 0 16.6 20c0-2.5-2.033-4.533-4.533-4.533-.767 0-1.567.2-2.234.6l-1.2-2.1c1.034-.6 2.234-.9 3.434-.9C15.9 13.067 19 16.167 19 20a6.86 6.86 0 0 1-.533 2.7Z',
      fill: '#FABB2E',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.733 23.633c-5.133 0-9.3-4.166-9.3-9.3 0-5.133 4.167-9.3 9.3-9.3 5.134 0 9.267 4.2 9.267 9.3 0 5.1-4.167 9.3-9.267 9.3Zm0-16.166a6.857 6.857 0 0 0-6.866 6.866c0 3.8 3.066 6.867 6.866 6.867s6.867-3.067 6.867-6.867-3.1-6.866-6.867-6.866Z',
      fill: '#2AABCE',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.733 23.633c-5.133 0-9.3-4.166-9.3-9.3 0-.666.534-1.2 1.2-1.2.667 0 1.2.534 1.2 1.2 0 3.8 3.067 6.867 6.867 6.867.667 0 1.2.533 1.2 1.2 0 .667-.5 1.233-1.167 1.233Z',
      fill: '#555390',
    }),
  );
});
moneyouSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var moneyou = {
  category: 'brand',
  colorable: false,
  name: 'moneyou',
  svg: moneyouSvg,
};
